import { Chip, ClickAwayListener, Popper } from "@mui/material";
import amplitude from "../../utils/ampli";
import React from "react";
// import { categoryMinimizer } from "../../utils/utils";

const CategoryMarketArrayGenerated = ({ data }) => {
  // Replace with your dynamic array generation
  console.log("Data received in CategoryMarketArrayGenerated:", data);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const chipRefs = React.useRef({});
  const [visibleEntries, setVisibleEntries] = React.useState([]);
  const [overflowEntries, setOverflowEntries] = React.useState([]);
  const entries = React.useMemo(() => {
    const rawEntries = Object.entries(data || {});
    const lastKeys = ["Length", "Width", "Height", "Ratio", "Table%", "Depth%", "Crown Angle", "Pav Angle"];
    const lastKeySet = new Set(lastKeys);
    const entryMap = new Map(rawEntries);
    const firstEntries = rawEntries.filter(([key]) => !lastKeySet.has(key));
    const lastEntries = lastKeys
      .filter((key) => entryMap.has(key))
      .map((key) => [key, entryMap.get(key)]);

    return [...firstEntries, ...lastEntries];
  }, [data]);

  const MAX_INLINE = 3;
  const MAX_CHIP_WIDTH = 205;

  const handleLastItemRendered = (event) => {
    event.stopPropagation();
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  // Get a reference to the last item in the array using a ref
  // const lastItemRef = React.useRef(null);

  React.useEffect(() => {
    if (open) {
      const buttonClickedEvent = {
        event_type: `v2_itemDetails_categories_hover`,
      };
      amplitude.track(buttonClickedEvent);
    }
  }, [open]);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMouseLeave = () => {
    setAnchorEl(null);
  };

  React.useLayoutEffect(() => {
    if (!entries.length) {
      setVisibleEntries([]);
      setOverflowEntries([]);
      return;
    }

    const visible = [];
    const overflow = [];

    entries.forEach(([key, value]) => {
      const chipEl = chipRefs.current[key];
      const width = chipEl ? chipEl.offsetWidth : 0;
      if (width > MAX_CHIP_WIDTH) {
        overflow.push([key, value]);
        return;
      }
      if (visible.length < MAX_INLINE) {
        visible.push([key, value]);
      } else {
        overflow.push([key, value]);
      }
    });

    setVisibleEntries(visible);
    setOverflowEntries(overflow);
  }, [entries]);

  return (
    <>
      <div style={{position:"absolute", visibility: "hidden", height: 0, overflow: "hidden" }}>
        {entries.map(([key, value]) => (
          <Chip
            key={`measure-${key}`}
            ref={(el) => {
              if (el) chipRefs.current[key] = el;
            }}
            label={`${key} : ${value}`}
            className="h-4 text-xs italic text-[0.54rem] text-[#8D8D8D]"
          />
        ))}
      </div>
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="bottom"
        modifiers={[
          { name: "offset", options: { offset: [0, 8] } },
          { name: "preventOverflow", options: { boundary: "viewport", padding: 8 } },
          { name: "flip", options: { fallbackPlacements: ["top-start"] } },
        ]}
        style={{ zIndex: 1000 }}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <div className="border flex flex-col max-w-[70%] border-gray-300 gap-1 justify-start items-start px-2 py-3 rounded-lg bg-white mt-2">
            {overflowEntries.map(([key, value]) => (
              <Chip
                key={key}
                label={`${key} : ${value}`}
                className="h-auto flex text-xs italic text-[0.54rem] text-[#8D8D8D] whitespace-normal break-words max-w-full"
                sx={{
                  height: "auto",
                  "& .MuiChip-label": {
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                  },
                }}
              />
            ))}
          </div>
        </ClickAwayListener>
      </Popper>

      <div className="flex gap-1 items-center">
       
        {visibleEntries.map(([key, value]) => (
          <Chip
            key={key}
            label={`${key} : ${value}`}
            className="h-4 text-xs italic text-[0.54rem] text-[#8D8D8D]"
          />
        ))}

        {overflowEntries.length > 0 ? (
          <div
            onMouseEnter={handleLastItemRendered}
            onMouseLeave={handleMouseLeave}
          >
            <Chip
              label={`${overflowEntries.length} more`}
              className="h-4 text-xs italic text-[0.54rem] text-[#8D8D8D]"
            />
          </div>
        ) : null}
      </div>
    </>
  );
};

export default CategoryMarketArrayGenerated;
